module.exports = __webpack_public_path__ + "static/media/ChatCircleDotsHover.c42676d6.svg";